import { ErrorObject, DefinedError, ValidateFunction } from 'ajv';
import { validatePrepAndSendRequest, validateEditorData, validateTemplate } from 'generated/validators/validateHelloRequest';

function parseErrorObject(err: ErrorObject): string {
  // https://ajv.js.org/api.html#error-parameters
  // DefinedError is a type for all pre-defined keywords errors, validate.errors
  // has type ErrorObject[] - to allow user-defined keywords with any error
  // parameters.  Users can extend DefinedError to include the keywords errors
  // they defined.
  switch ((err as DefinedError).keyword) {
    default: {
      const { instancePath, message, ...rest } = err;
      return `${instancePath} ${message} [${JSON.stringify(rest)}]`;
    }
  }
}

/**
 * The errors this throws is not intended to show to users. There is nothing
 * they can do about schema-level errors.
 */
export function assertDataIsValid<T>(
  validator: ValidateFunction<T>,
  data: unknown,
): asserts data is T {
  if (!validator(data)) {
    for (const err of (validator.errors ?? [])) {
      throw new Error(parseErrorObject(err));
    }
  }
}

// These functions were autogenerated by the script located at
// `scripts/generate-json-validators`
// so they aren't exactly well-formatted enough to be debug-friendly
// Please use the schemas located at schemas/UnifiedJSON, to debug validation errors.

export {
  validatePrepAndSendRequest,
  validateTemplate,
  validateEditorData,
};
